export const wmsConfig = '?bbox={bbox-epsg-3857}&format=image/png&service=WMS&&version=1.1.1&request=GetMap&srs=EPSG:900913&transparent=true&width=256&height=256&layers=';

export const baseLayerStyles = [
    {
        id: 'SATELLITE',
        base: true,
        title: 'Satellite',
        img: 'assets/images/SATELLITE.png',
        // img: 'https://i.ibb.co/KwxzMbr/SATELLITE.png',
        link: 'mapbox://styles/mapbox/satellite-v9'
    },
    {
        id: 'OSM',
        base: false,
        title: 'Open Street Map',
        img: 'assets/images/OSM.png',
        // img: 'https://i.ibb.co/NTL3dpK/OSM.png',
        link: 'mapbox://styles/mapbox/streets-v12'
    },
    {
        id: 'SIMPLE',
        base: false,
        title: 'Simple Basemap',
        img: 'assets/images/SIMPLE.png',
        // img: 'https://i.ibb.co/98Y7MGT/SIMPLE.png',
        link: 'mapbox://styles/mapbox/light-v11'
    },
];

export interface STYLES {
    minZoom: number;
    maxZoom: number;
    colorType: 'SAME_COLOR' | 'RANGE_COLOR';
    colorRangeField: string;
    colorRangeValue: number;
    backgroundValue: any;
    backgroundOpacity: number;
    backgroundStops: any;
    lineColorValue: any;
    lineColorStops: any;
    lineStyle: 'solid' | 'dashed';
    lineWidth: number;
    iconImage: any;
    lineDashArray: string;
    labelVisible: boolean;
    labelMinZoom: number;
    labelMaxZoom: number;
    labelTextAnchor: 'center' | 'top';
    labelTextFont: string[];
    labelTextField: string;
    labelTextColor: string;
    labelTextOpacity: any;
    labelTextFontSize: number;
    labelTextHaloWidth: number;
    labelTextHaloColor: string;
    labelTextIgnorePlacement: boolean;
    labelTextOffset: number[];
    labelTextAllowOverlap: boolean;
    labelTextSymbolPlacement: 'point' | 'line' | 'line-center';
    symbolType: string;
    symbolSize: any;
    symbolHaloWidth: any;
    symbolHaloColor: string;
    symbolAllowOverlap: boolean;
    symbolIgnorePlacement: boolean;
    sourceLayer: string;
}

export const datasetTypes = {
    WMS: 'WMS',
    LINE: 'LINE',
    POINT: 'POINT',
    GEOJSON: 'GEOJSON',
    POLYGON: 'POLYGON',
    POLYLINE: 'POLYLINE',
};

export const LAYER_SURFIX = {
    FILL: '-fill',
    LINE: '-line',
    WMS: '-wms',
    ICON_SYMBOL: '-icon-symbol',
    TEXT_SYMBOL: '-text-symbol',
    DEFAULT_FILL: '-default-fill',
    HIGHLIGHT: '-highlight'
};

export const actionNames = {
    SELECT_SAME_COLOR_TYPE: 'SELECT_SAME_COLOR_TYPE',
    SELECT_RANGE_COLOR_TYPE: 'SELECT_RANGE_COLOR_TYPE',
    CHANGE_ZOOM: 'CHANGE_ZOOM',
    CHANGE_ZOOM_LABEL: 'CHANGE_ZOOM_LABEL',
    SELECT_FILL_COLOR: 'SELECT_FILL_COLOR',
    SELECT_LINE_COLOR: 'SELECT_LINE_COLOR',
    SELECT_COLOR_FIELD: 'SELECT_COLOR_FIELD',
    SELECT_COLOR_RANGE: 'SELECT_COLOR_RANGE',
    SELECT_LINE_TYPE: 'SELECT_LINE_TYPE',
    INPUT_DASH_ARRAY: 'INPUT_DASH_ARRAY',
    CHANGE_LINE_WIDTH: 'CHANGE_LINE_WIDTH',
    CHANGE_STOPS: 'CHANGE_STOPS',
    SELECT_SYMBOL_TYPE: 'SELECT_SYMBOL_TYPE',
    CHANGE_SYMBOL_SIZE: 'CHANGE_SYMBOL_SIZE',
    CHANGE_SYMBOL_HALO_WIDTH: 'CHANGE_SYMBOL_HALO_WIDTH',
    CHANGE_SYMBOL_HALO_COLOR: 'CHANGE_SYMBOL_HALO_COLOR',
    CHANGE_SYMBOL_OVERLAP: 'CHANGE_SYMBOL_OVERLAP',
};

export interface TOOL {
    name: string;
    iconClass: string;
    code: string;
    active: boolean;
    className?: string;
}

export const iCons = [
    {
        type: 'point',
        image: 'assets/images/point.png',
        // image: 'https://i.ibb.co/fkQfyZ8/point.png'
    },
];

export enum ToolTypes {
    draw_line_string = 'draw_line_string',
    draw_polygon = 'draw_polygon',
    simple_select = 'simple_select',
    change_style = 'change_style',
    feature_info = 'feature_info',
    search_item = 'search_item',
    layer_item = 'layer_item',
    data_graph = 'data_graph',
    // Custom navigation control
    custom_zoom_in = 'custom_zoom_in',
    custom_zoom_out = 'custom_zoom_out',
    custom_compass = 'custom_compass',
    draw_remove = ' draw_remove',
}

export const featureInfoPopupWidth = 350;
export const featureInfoPopupHeight = 405;

export const mapFields = {
    Dibrugarh_boundary: {
        click: false,
        title: 'Dibrugarh boundary',
        fields: {
            id_0: 'id_0',
            iso: 'iso',
            name_0: 'name_0',
            id_1: 'id_1',
            name_1: 'name_1',
            id_2: 'id_2',
            name_2: 'name_2',
            type_2: 'type_2',
            engtype_2: 'engtype_2',
            nl_name_2: 'nl_name_2',
            varname_2: 'varname_2',
        }
    },
    watershed: {
        click: true,
        title: 'Watershed',
        fields: {
            region: 'Region',
            type: 'Watershed type',
            river_name: 'Watershed of the river',
            area: 'Area (Km²)',
            runoff: 'Runoff capacity (m³)',
        }
    },
    Municipal_boundary: {
        click: false,
        title: 'Municipal boundary',
        fields: {
            id: 'id',
        }
    },
    Master_plan_boundary: {
        click: false,
        title: 'Master plan boundary',
        fields: {
            id: 'id',
        }
    },
    // DONE
    subbasin: {
        click: true,
        title: 'Subbasin',
        fields: {
            subbasin: 'Subbasin',
            area: 'Area (Km²)',
            total_flow: 'Total flow into the subbasin (m³)',
            runoff: 'Runoff generated (m³)',
            dtpcap100: '100% drain capacity running through DTP drain (m³)',
            rajacap100: '100% drain capacity running through Rajabheta drain (m³)',
            dtpcap80: '80% drain capacity running through DTP drain (m³)',
            rajacap80: '80% drain capacity running through Rajabheta drain (m³)',
            drain_cap: 'Drain capacity running through the subbasin (m³)',
            e_drain: 'Existing drain cleaning',
            e_pump: 'Existing pumping stations',
            p_wetland: 'Potential contructed wetlands',
            p_drainage: 'Potential natural drainage path restoration',
            p_park: 'Potential sponge gardens and pocket parks',
            p_garden: 'Potential retention ponds and rain gardens',
            p_enhance: 'Potential drainage corridor enhancement',
            p_stormwt: 'Potential stormwater infiltration',
            p_paving: 'Potential pervious paving',
        }
    },
    floodprone: {
        click: true,
        title: 'Flood Prone',
        fields: {
            area: 'Area (Km²)',
        }
    },
    Wetlands: {
        click: true,
        title: 'Wetlands',
        fields: {
            area: 'Area (Km²)',
        }
    },
    Drainage: {
        click: true,
        title: 'Drainage',
        fields: {
            name: 'Name',
            length: 'Length',
        }
    },
    River: {
        click: false,
        title: 'River',
        fields: {
            river_name: 'river_name',
        }
    },
    District_headquarter: {
        click: false,
        title: 'District headquarter',
        fields: {
            objectid: 'objectid',
            area: 'area',
            perimeter: 'perimeter',
            indiadpt_: 'indiadpt_',
            indiadpt_i: 'indiadpt_i',
            hq: 'hq',
            town: 'town',
            state: 'state',
            taluk: 'taluk',
            sheet: 'sheet',
            admstatus: 'admstatus',
            class: 'class',
            populn: 'populn',
            dxf_layer: 'dxf_layer',
            dxf_color: 'dxf_color',
            x_coord: 'x_coord',
            y_coord: 'y_coord',
            polygonid: 'polygonid',
            scale: 'scale',
            angle: 'angle',
            district: 'district',
        }
    }
};
